/**
 * 创建请求队列
 * @param {number} maxConcurrentRequests 最大并发请求数量
 * @returns {object} 请求队列对象
 */
export function createRequestQueue(maxConcurrentRequests, cloudRender) {
  let queue = [] // 存储请求的队列
  let runningCount = 0 // 当前正在运行的请求数量
  let dateData = {} //日期和数据的映射
  let requestStatus = true // 是否开启了请求
  /**
   * 处理下一个请求
   */
  async function processNextRequest() {
    if (runningCount >= maxConcurrentRequests || queue.length === 0 || !requestStatus) return
    runningCount++
    const request = queue.shift() // 获取队列中的下一个请求
    try {
      const result = await request() // 执行请求
      dateData[result.date] = result.res
      cloudRender.Progress.setProgressData(result.date, {
        workAsPlan: result.res.workAsPlan,
        workDelayPlan: result.res.workDelayPlan,
        workDelayDone: result.res.workDelayDone,
        delayPlanStart: result.res.delayPlanStart,
        noWork: result.res.noWork,
        alreadyDone: result.res.alreadyDone,
        notInRange: result.res.notInRange
      })
    } catch (error) {
    } finally {
      runningCount--
      processNextRequest() // 处理下一个请求
    }
  }

  return {
    /**
     * 添加请求到队列
     * @param {function} request 请求函数，返回 Promise
     * @returns {Promise} 请求的 Promise 对象
     */
    add(request, date) {
      return new Promise((resolve, reject) => {
        queue.push(async () => {
          try {
            const [err, res] = await request() // 执行请求
            if (!err && res) {
              resolve({ res, date }) // 请求成功，返回结果
              return { res, date }
            } else {
              reject({ err, date }) // 请求失败，返回错误信息
              return { err, date }
            }
          } catch (error) {
            reject({ error, date }) // 请求失败，返回错误信息
            return { err, date }
          }
        })

        processNextRequest() // 添加请求后，处理下一个请求
      })
    },
    // 关闭请求
    closeRequest() {
      queue = []
      return new Promise((resolve, reject) => {
        let interval = null
        interval = setInterval(() => {
          if (runningCount === 0) {
            resolve()
          }
        }, 500)
      })
    },
    // 暂停请求
    stopRequest() {
      requestStatus = false
    },
    // 重启请求
    restartRequest() {
      requestStatus = true
      processNextRequest()
    },
    getDataByDate(date) {
      return dateData[date]
    }
  }
}
